var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{attrs:{"id":"comoFunciona"}},[_c('BannerImagem',{attrs:{"image":_vm.conteudo.banner}}),_c('TituloPagina',{attrs:{"titulo":_vm.conteudo.titulo}}),_c('Investimento'),_c('Lei')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }